module.exports = __webpack_public_path__ + "2c5092929f8a46963cf18809aa3f84ce.svg";